import React, { useState } from "react";
import { Badge, Button, Card, Col, Form, Row } from "react-bootstrap";

const TurnaroundMetrics = () => {
  const [slaRules, setSlaRules] = useState({
    critical: 2,
    high: 5,
    medium: 10,
    low: 15,
  });

  const metrics = [
    {
      title: "CREATION → SITE RESPONSE",
      value: "5.9 days avg",
    },
    {
      title: "RESPONSE → CRA/DM REVIEW",
      value: "3.8 days avg",
    },
    {
      title: "CREATION → CLOSURE",
      value: "9.8 days avg",
    },
    {
      title: "MEDIAN CLOSURE TIME",
      value: "9 days",
    },
    {
      title: "90TH PERCENTILE CLOSURE",
      value: "16 days",
    },
    {
      title: "SLOWEST CATEGORY",
      value: "SDV discrepancy (10.9 d)",
    },
    {
      title: "SLA COMPLIANCE RATE",
      value: "49.1%",
      color: "danger",
    },
    {
      title: "RE-OPEN RATE",
      value: "8.5%",
    },
  ];

  return (
    <>
      <div className="p-3">
        <Row className="g-2 mb-3">
          {metrics.map((item, index) => (
            <Col xl={3} lg={4} md={6} sm={12} key={index}>
              <Card className="h-100 border bg-light">
                <Card.Body className="p-2">
                  <div
                    className="text-uppercase fw-bold text-secondary"
                    style={{
                      fontSize: 10,
                      letterSpacing: "0.5px",
                    }}
                  >
                    {item.title}
                  </div>

                  <small
                    className={`mt-1 ${item.color ? `text-${item.color}` : ""}`}
                  >
                    {item.value}
                  </small>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {/* SLA Rules */}
        <small>SLA rules (admin-configurable):</small>
        <div className="d-flex flex-wrap align-items-center gap-3">

          <div className="d-flex align-items-center gap-2">
            <Badge bg="danger">Critical</Badge>

            <Form.Control
              size="sm"
              style={{ width: 50 }}
              value={slaRules.critical}
              onChange={(e) =>
                setSlaRules({
                  ...slaRules,
                  critical: e.target.value,
                })
              }
            />
            <small>days</small>
          </div>

          <div className="d-flex align-items-center gap-2">
            <Badge bg="danger-subtle" text="danger">
              High
            </Badge>

            <Form.Control
              size="sm"
              style={{ width: 50 }}
              value={slaRules.high}
              onChange={(e) =>
                setSlaRules({
                  ...slaRules,
                  high: e.target.value,
                })
              }
            />
            <small>days</small>
          </div>

          <div className="d-flex align-items-center gap-2">
            <Badge bg="warning" text="dark">
              Medium
            </Badge>

            <Form.Control
              size="sm"
              style={{ width: 50 }}
              value={slaRules.medium}
              onChange={(e) =>
                setSlaRules({
                  ...slaRules,
                  medium: e.target.value,
                })
              }
            />
            <small>days</small>
          </div>

          <div className="d-flex align-items-center gap-2">
            <Badge bg="info" text="dark">
              Low
            </Badge>

            <Form.Control
              size="sm"
              style={{ width: 50 }}
              value={slaRules.low}
              onChange={(e) =>
                setSlaRules({
                  ...slaRules,
                  low: e.target.value,
                })
              }
            />
            <small>days</small>
          </div>

          <button className="updateProfile">
            Recalculate
          </button>
        </div>
      </div>
    </>
  );
};

export default TurnaroundMetrics;
